export default __webpack_public_path__ + "f97b4fb60939e18dbdb88ba8bf20e153.png";